<template>
  <div id="growing_components" class="p-42 my-52 growing-container fc-15253C">
    <div class="relative">
      <div
        @click.prevent="showVideo"
        class="absolute-header"
        style="top: -17px; right: 0"
      >
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div class="fs-18 fw-900">
      {{ $t("weMonthlyInsights.growing.howAreWe") }}
    </div>
    <div class="flex">
      <div v-if="user.boss" class="opa-07 fc-15253C">
        {{ $t("weMonthlyInsights.growing.progressBasedOnBoss") }}
      </div>
      <div v-else class="opa-07 fc-15253C">
        {{ $t("weMonthlyInsights.growing.progressBasedOn") }}
      </div>
      <!-- <div class="ml-auto flex fs-12" style="width: 200px">
        <div
          @click.prevent="activeGrowingTab = 'directReports'"
          :class="`tab-header flex-mid left ${
            activeGrowingTab === 'directReports' ? 'active-tab' : ''
          }`"
          style="width: 120px"
        >
          Direct Reports Only
        </div>
        <div
          @click.prevent="activeGrowingTab = 'overallTeam'"
          :class="`tab-header flex-mid right ${
            activeGrowingTab === 'overallTeam' ? 'active-tab' : ''
          }`"
          style="width: 80px"
        >
          Overall Team
        </div>
      </div> -->
    </div>
    <div class="mt-24 relative mx-auto" style="width: 716px">
      <div class="flex-wrap ml-24 font-lato" v-if="loadingStatus">
        <div
          v-for="value in [
            'id1',
            'id2',
            'id3',
            'id4',
            'id5',
            'id6',
            'id7',
            'id8',
            'id9',
            'id10',
            'id11',
            'id12',
            'id13',
            'id14',
            'id15',
            'id16',
            'id17',
            'id18',
            'id19',
            'id20',
          ]"
          :key="'card-' + value"
          :class="`growing-card flex-center`"
        >
          <div class="mx-auto">
            <div class="title text-skeleton" style="width: 120px">&nbsp;</div>
            <div class="flex-mid">
              <span class="text-skeleton mt-8" style="width: 25px">&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex-wrap ml-24 font-lato"
        v-else-if="activeGrowingTab === 'directReports'"
      >
        <div
          v-for="value in growingData.directReports"
          :key="'card-' + value.name"
          :class="`${growingCardStyle(value)}`"
        >
          <div class="mx-auto" v-if="user.boss">
            <div class="title">{{ renameTalent(value.name) }}</div>
            <div class="flex-mid">
              <span class="value">{{ value.value }}</span>
            </div>
          </div>
          <div class="mx-auto" v-if="value.highlight && !user.boss">
            <div class="flex-mid">
              <span class="title">{{
                $t("weMonthlyInsights.growing.youAreHere")
              }}</span>
            </div>
          </div>
          <div class="mx-auto" v-if="value.grayBlock && !user.boss">
            <div class="flex-mid">
              <span class="title">{{
                $t("weMonthlyInsights.growing.youWereHere")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-wrap ml-24 font-lato" v-else>
        <div
          v-for="value in growingData.overallTeam"
          :key="'card-' + value.name"
          :class="`growing-card flex-center ${
            value.highlight ? 'highlight' : ''
          } ${value.grayBlock ? 'gray-block' : ''}`"
        >
          <div class="mx-auto" v-if="user.boss">
            <div class="title">{{ value.name }}</div>
            <div class="flex-mid">
              <span class="value">{{ value.value }}</span>
            </div>
          </div>
          <div class="mx-auto" v-if="value.highlight && !user.boss">
            <div class="flex-mid">
              <span class="title">{{
                $t("weMonthlyInsights.growing.youAreHere")
              }}</span>
            </div>
          </div>
          <div class="mx-auto" v-if="value.grayBlock && !user.boss">
            <div class="flex-mid">
              <span class="title">{{
                $t("weMonthlyInsights.growing.youWereHere")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="left-text">
        <span class="left">&nbsp;</span>
        <span style="background-color: #fff">{{
          $t("weMonthlyInsights.growing.individualPerformance")
        }}</span>
        <span class="right">&nbsp;</span>
      </div>
      <div style="width: 668px" class="ml-30 mt-4">
        <div class="line-label fs-16 fw-700 mt-10">
          <span class="label">{{
            $t("weMonthlyInsights.growing.networkEffectiveness")
          }}</span>
          <span class="arrow">&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="mt-36">
      <div v-if="loadingStatus" class="mt-36">
        <div class="profile-card" style="background-color: #f7f4fc">
          <div class="profile top flex-center">
            <div class="image-skeleton image-profile-42 flex-mid mr-16"></div>
            <div class="text-skeleton" style="min-width: 110px; width: 40px">
              &nbsp;
            </div>
            <div class="ml-auto flex-center">
              <div class="fc-000000 fs-13 mr-12">
                {{ $t("weMonthlyInsights.growing.s_starPerformer") }}
              </div>
              <div class="fs-30" style="color: #fbb040">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="fc-000000 pb-4 mr-4">x</div>
              <div class="fs-20 fw-700 text-skeleton" style="width: 20px">
                &nbsp;
              </div>
            </div>
          </div>
          <div class="font-lato profile bottom flex-center">&nbsp;</div>
        </div>
      </div>
      <div v-else class="profile-card">
        <div class="profile top flex-center" style="background-color: #f7f4fc">
          <div v-if="user.image">
            <img
              v-lazy="user.image"
              :key="user.image"
              class="image-skeleton image-profile-42 flex-mid mr-16"
            />
          </div>
          <div v-else class="image image-profile-42 flex-mid mr-16">
            <div
              class="flex-mid text-in-image text-in-image-42"
              style="width: 42px"
            >
              {{
                $utils("acronymName", {
                  firstName: user.firstname,
                  lastName: user.lastname,
                })
              }}
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 130px"
          >
            {{ user.name }}
          </div>
          <!-- <div v-if="user.boss" class="flex-center">
            <div v-if="userCardData.talentChanged" class="flex-center">
              <span class="talent old">{{ userCardData.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="userCardData.talent" class="talent now">{{
              userCardData.talent
            }}</span>
          </div> -->
          <el-tooltip effect="light" content="fs-12">
            <div
              slot="content"
              :style="
                $utils(
                  'fontStyle',
                  $t('weMonthlyInsights.growing.A_score_that_represents')
                )
              "
              class="tooltop"
            >
              <div class="fs-15 fw-700">
                {{ $t("weMonthlyInsights.growing.Impact_Rating") }}
              </div>
              <div class="mt-6">
                {{ $t("weMonthlyInsights.growing.A_score_that_represents") }}
              </div>
              <br />
              <div>
                <span class="fw-700">Talent Type</span> :
                <span
                  class="fw-900"
                  :style="`${toolTipClass(userCardData.talentClass)}`"
                >
                  {{ toolTipStatus(userCardData.talentClass) }}
                </span>
                {{ $t("weMonthlyInsights.growing.Based_on_manager_and") }}
              </div>
              <br />
              <div>
                <span class="fw-700">{{
                  $t("weMonthlyInsights.growing.Network_Type")
                }}</span>
                :
                <span
                  class="fw-900"
                  :style="`${toolTipClass(userCardData.networkClass)}`"
                >
                  {{ toolTipStatus(userCardData.networkClass) }}
                </span>
                {{
                  $t("weMonthlyInsights.growing.Based_on_connections_created")
                }}
              </div>
              <br />
              <div>
                <span class="fw-700">Engagement Group</span> :
                <span
                  class="fw-900"
                  :style="`${toolTipClass(userCardData.engagementClass)}`"
                >
                  {{ toolTipStatus(userCardData.engagementClass) }}
                </span>
                {{ $t("weMonthlyInsights.growing.Based_on_the_quality_and") }}
              </div>
              <br />
              <div>
                <span class="fw-700">Medals</span>
                : {{ $t("weMonthlyInsights.growing.Medals_received_in_the") }}
              </div>
              <br />
              <div>
                <span class="fw-700">Truly Outstanding</span> :
                <span
                  class="fw-900"
                  :style="`${toolTipClass(userCardData.trulyClass)}`"
                >
                  {{ toolTipStatus(userCardData.trulyClass) }}
                </span>
                {{
                  $t("weMonthlyInsights.growing.Truly_Outstanding_ratings_from")
                }}
              </div>
              <br />
              <div class="">
                <span class="fw-700">Star Performer</span> :
                <span
                  class="fw-900"
                  :style="`${toolTipClass(userCardData.starClass)}`"
                >
                  {{ toolTipStatus(userCardData.starClass) }}
                </span>
                {{ $t("weMonthlyInsights.growing.Number_of_weeks_qualified") }}
              </div>
            </div>
            <div class="ml-auto flex-center">
              <div class="ml-auto flex-center ml-auto">
                <div class="fw-700 fs-12">
                  {{ $t("weMonthlyInsights.growing.Impact_Rating") }}
                </div>
                <img
                  :src="$utils('icons', 'ic_help_gray_24px')"
                  class="ml-6"
                  alt="icons_ic_help_gray_24px"
                />
              </div>
              <div class="flex-center fs-12 fw-700">
                <div
                  :class="`impact-tag ml-12 flex-mid impact-tag-${
                    userCardData.impact_rating < 40
                      ? 'red'
                      : userCardData.impact_rating < 70
                      ? 'yellow'
                      : 'green'
                  }`"
                >
                  {{ userCardData.impact_rating }}
                </div>
                <div
                  v-if="
                    userCardData.impact_rating >
                    userCardData.impact_rating_lastweek
                  "
                  class="fc-66BB6A flex-center"
                >
                  <img
                    :src="$utils('icons', 'arrow_up_green_24dp')"
                    alt="icons_arrow_up_green_24dp"
                  />
                  <div style="margin-left: -4px" class="fc-66BB6A">
                    {{ userCardData.impact_rating_change }}
                  </div>
                </div>
                <div
                  v-else-if="
                    userCardData.impact_rating_lastweek >
                    userCardData.impact_rating
                  "
                  class="fc-F44336 flex-center"
                >
                  <img
                    :src="$utils('icons', 'arrow_down_red_24dp')"
                    alt="icons_arrow_down_red_24dp"
                  />
                  <div style="margin-left: -4px">
                    {{ userCardData.impact_rating_change }}
                  </div>
                </div>
                <div
                  v-else-if="
                    userCardData.impact_rating ==
                    userCardData.impact_rating_lastweek
                  "
                ></div>
              </div>
            </div>
          </el-tooltip>
        </div>
        <div
          class="font-lato profile bottom flex-center fc-000000 fw-700 fs-12"
        >
          <div>Talent Type</div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              userCardData.talent
            )}`"
          >
            <span>{{ renameTalent(userCardData.talent) }}</span>
          </div>
          <div class="ml-12">
            {{ $t("weMonthlyInsights.growing.Network_Type") }}
          </div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              userCardData.network_type
            )}`"
          >
            <span>{{ userCardData.network_type }}</span>
          </div>
          <div class="ml-auto">
            {{ $t("weMonthlyInsights.growing.Achievements") }}
          </div>
          <div class="flex-center ml-12" style="height: 50px">
            <div class="achievements-contariner">
              <img
                v-if="userCardData.engagedType == 'highlyEngaged'"
                :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                alt="icons_Engagement_Highly_Engaged_32"
                title="Highly Engaged"
              />
              <img
                v-else-if="userCardData.engagedType == 'moderatelyEngaged'"
                :src="$utils('icons', 'Engagement_Moderately_Engaged_32')"
                alt="icons_Engagement_Moderately_Engaged_32"
                title="Engaged"
              />
              <img
                v-else-if="userCardData.engagedType == 'somewhatEngaged'"
                :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                alt="icons_Engagement_Somewhat_Engaged_32"
                title="Somewhat Engaged"
              />
              <img
                v-else-if="userCardData.engagedType == 'underEngaged'"
                :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                alt="icons_Engagement_Under_Engaged_32"
                title="Under Engaged"
              />
              <img
                v-else-if="userCardData.engagedType == 'inActive'"
                :src="$utils('icons', 'Engagement_In-Active_32')"
                alt="icons_Engagement_In-Active_32"
                title="In-Active"
              />
              <div v-else class="engagement-no-data flex-mid">No Data</div>
            </div>
            <div
              :class="`achievements-contariner ${
                userCardData.medalCount < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="userCardData.medalCount > 0" class="count-icon">
                {{ userCardData.medalCount }}
              </div>
              <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" />
            </div>

            <div
              :class="`achievements-contariner ${
                userCardData.truly == undefined || userCardData.truly == 0
                  ? 'no-have'
                  : ''
              }`"
            >
              <div v-if="userCardData.truly > 0" class="count-icon">
                {{ userCardData.truly }}
              </div>
              <img
                :src="$utils('icons', 'Outstanding_32')"
                alt="icons_Outstanding_32"
              />
            </div>
            <div
              :class="`achievements-contariner ${
                userCardData.star < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="userCardData.star > 0" class="count-icon">
                {{ userCardData.star }}
              </div>
              <img
                :src="$utils('icons', 'Super_Star_32')"
                alt="icons_Super_Star_32"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="user.boss"
      class="fs-16 fw-700 fc-000000 font-lato opa-08 mt-34 mb-24"
    >
      {{ $t("weMonthlyInsights.growing.yourDirectReports") }}
    </div>
    <div v-if="loadingStatus">
      <div class="profile-card">
        <div class="profile top flex-center">
          <div class="image-skeleton image-profile-42 flex-mid mr-16"></div>
          <div class="text-skeleton" style="min-width: 110px; width: 40px">
            &nbsp;
          </div>
          <div class="ml-auto flex-center">
            <div
              class="text-skeleton fc-000000 fs-13 mr-12 mr-40"
              style="width: 140px"
            >
              &nbsp;
            </div>
          </div>
        </div>
        <div class="font-lato profile bottom flex-center">
          <div class="fs-12">&nbsp;</div>
        </div>
      </div>
    </div>
    <div
      v-else-if="user.boss"
      v-for="(user, index) in directReportsCardData"
      :key="'userCard_' + index + user.name"
    >
      <div v-if="index < 3" class="profile-card mt-12">
        <div class="profile top flex-center">
          <div v-if="user.image">
            <img
              v-lazy="user.image"
              :key="user.image"
              class="image-skeleton image-profile-42 flex-mid mr-16"
            />
          </div>
          <div v-else class="image image-profile-42 flex-mid mr-16">
            <div
              class="flex-mid text-in-image text-in-image-42"
              style="width: 42px"
            >
              {{
                $utils("acronymName", {
                  firstName: user.firstname,
                  lastName: user.lastname,
                })
              }}
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 110px"
          >
            {{ user.name }}
          </div>
          <!-- <div class="flex-center">
            <div v-if="user.talentChanged" class="flex-center">
              <span class="talent old">{{ user.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="user.talent" class="talent now">{{ user.talent }}</span>
          </div> -->
          <div class="flex-center fs-12 fw-700 ml-auto">
            <div class="fw-700 fs-12">
              {{ $t("weMonthlyInsights.growing.Impact_Rating") }}
            </div>
            <!-- 60.2 is now value, 65.1 is old value, 4.9 is how change -->
            <div
              :class="`impact-tag ml-12 flex-mid impact-tag-${
                user.impact_rating < 40
                  ? 'red'
                  : user.impact_rating < 70
                  ? 'yellow'
                  : 'green'
              }`"
            >
              {{ user.impact_rating }}
            </div>
            <div
              v-if="user.impact_rating > user.impact_rating_lastweek"
              class="fc-66BB6A flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_up_green_24dp')"
                alt="icons_arrow_up_green_24dp"
              />
              <div style="margin-left: -4px" class="fc-66BB6A">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div
              v-else-if="user.impact_rating_lastweek > user.impact_rating"
              class="fc-F44336 flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_down_red_24dp')"
                alt="icons_arrow_down_red_24dp"
              />
              <div style="margin-left: -4px">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div v-else-if="user.impact_rating == user.impact_rating_lastweek">
              <!-- <img :src="$utils('icons', 'arrow_down_red_24dp')" alt="icons_arrow_down_red_24dp" />
                  <div style="margin-left: -4px">{{ scope.row.impact_compare }}</div> -->
            </div>
          </div>
        </div>
        <div
          class="font-lato profile bottom flex-center fc-000000 fw-700 fs-12"
        >
          <div>Talent Type</div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.talent
            )}`"
          >
            <span>{{ renameTalent(user.talent) }}</span>
          </div>
          <div class="ml-12">
            {{ $t("weMonthlyInsights.growing.Network_Type") }}
          </div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.network_type
            )}`"
          >
            <span>{{ user.network_type }}</span>
          </div>
          <div class="ml-auto">
            {{ $t("weMonthlyInsights.growing.Achievements") }}
          </div>
          <div class="flex-center ml-12" style="height: 50px">
            <div class="achievements-contariner">
              <img
                v-if="user.engagedType == 'highlyEngaged'"
                :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                alt="icons_Engagement_Highly_Engaged_32"
                title="Highly Engaged"
              />
              <img
                v-else-if="user.engagedType == 'moderatelyEngaged'"
                :src="$utils('icons', 'Engagement_Moderately_Engaged_32')"
                alt="icons_Engagement_Moderately_Engaged_32"
                title="Engaged"
              />
              <img
                v-else-if="user.engagedType == 'somewhatEngaged'"
                :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                alt="icons_Engagement_Somewhat_Engaged_32"
                title="Somewhat Engaged"
              />
              <img
                v-else-if="user.engagedType == 'underEngaged'"
                :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                alt="icons_Engagement_Under_Engaged_32"
                title="Under Engaged"
              />
              <img
                v-else-if="user.engagedType == 'inActive'"
                :src="$utils('icons', 'Engagement_In-Active_32')"
                alt="icons_Engagement_In-Active_32"
                title="In-Active"
              />
              <div v-else class="engagement-no-data flex-mid">No Data</div>
            </div>
            <div
              :class="`achievements-contariner ${
                user.medalCount < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.medalCount > 0" class="count-icon">
                {{ user.medalCount }}
              </div>
              <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" />
            </div>
            <div
              :class="`achievements-contariner ${
                user.truly == undefined || user.truly == 0 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.truly > 0" class="count-icon">
                {{ user.truly }}
              </div>
              <img
                :src="$utils('icons', 'Outstanding_32')"
                alt="icons_Outstanding_32"
              />
            </div>
            <div
              :class="`achievements-contariner ${
                user.star < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.star > 0" class="count-icon">
                {{ user.star }}
              </div>
              <img
                :src="$utils('icons', 'Super_Star_32')"
                alt="icons_Super_Star_32"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="showMoreDirectReport" class="profile-card mt-12">
        <div class="profile top flex-center">
          <div v-if="user.image">
            <img
              v-lazy="user.image"
              :key="user.image"
              class="image-skeleton image-profile-42 flex-mid mr-16"
            />
          </div>
          <div v-else class="image image-profile-42 flex-mid mr-16">
            <div
              class="flex-mid text-in-image text-in-image-42"
              style="width: 42px"
            >
              {{
                $utils("acronymName", {
                  firstName: user.firstname,
                  lastName: user.lastname,
                })
              }}
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 110px"
          >
            {{ user.name }}
          </div>
          <!-- <div class="flex-center">
            <div v-if="user.talentChanged" class="flex-center">
              <span class="talent old">{{ user.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="user.talent" class="talent now">{{ user.talent }}</span>
          </div> -->
          <div class="flex-center fs-12 fw-700 ml-auto">
            <div class="fw-700 fs-12">
              {{ $t("weMonthlyInsights.growing.Impact_Rating") }}
            </div>
            <!-- 60.2 is now value, 65.1 is old value, 4.9 is how change -->
            <div
              :class="`impact-tag ml-12 flex-mid impact-tag-${
                user.impact_rating < 40
                  ? 'red'
                  : user.impact_rating < 70
                  ? 'yellow'
                  : 'green'
              }`"
            >
              {{ user.impact_rating }}
            </div>
            <div
              v-if="user.impact_rating > user.impact_rating_lastweek"
              class="fc-66BB6A flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_up_green_24dp')"
                alt="icons_arrow_up_green_24dp"
              />
              <div style="margin-left: -4px" class="fc-66BB6A">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div
              v-else-if="user.impact_rating_lastweek > user.impact_rating"
              class="fc-F44336 flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_down_red_24dp')"
                alt="icons_arrow_down_red_24dp"
              />
              <div style="margin-left: -4px">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div v-else-if="user.impact_rating == user.impact_rating_lastweek">
              <!-- <img :src="$utils('icons', 'arrow_down_red_24dp')" alt="icons_arrow_down_red_24dp" />
                  <div style="margin-left: -4px">{{ scope.row.impact_compare }}</div> -->
            </div>
          </div>
        </div>
        <div
          class="font-lato profile bottom flex-center fc-000000 fw-700 fs-12"
        >
          <div>Talent Type</div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.talent
            )}`"
          >
            <span>{{ renameTalent(user.talent) }}</span>
          </div>
          <div class="ml-12">
            {{ $t("weMonthlyInsights.growing.Network_Type") }}
          </div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.network_type
            )}`"
          >
            <span>{{ user.network_type }}</span>
          </div>
          <div class="ml-auto">
            {{ $t("weMonthlyInsights.growing.Achievements") }}
          </div>
          <div class="flex-center ml-12" style="height: 50px">
            <div class="achievements-contariner">
              <img
                v-if="user.engagedType == 'highlyEngaged'"
                :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                alt="icons_Engagement_Highly_Engaged_32"
                title="Highly Engaged"
              />
              <img
                v-else-if="user.engagedType == 'moderatelyEngaged'"
                :src="$utils('icons', 'Engagement_Moderately_Engaged_32')"
                alt="icons_Engagement_Moderately_Engaged_32"
                title="Engaged"
              />
              <img
                v-else-if="user.engagedType == 'somewhatEngaged'"
                :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                alt="icons_Engagement_Somewhat_Engaged_32"
                title="Somewhat Engaged"
              />
              <img
                v-else-if="user.engagedType == 'underEngaged'"
                :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                alt="icons_Engagement_Under_Engaged_32"
                title="Under Engaged"
              />
              <img
                v-else-if="user.engagedType == 'inActive'"
                :src="$utils('icons', 'Engagement_In-Active_32')"
                alt="icons_Engagement_In-Active_32"
                title="In-Active"
              />
              <div v-else class="engagement-no-data flex-mid">No Data</div>
            </div>
            <div
              :class="`achievements-contariner ${
                user.medalCount < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.medalCount > 0" class="count-icon">
                {{ user.medalCount }}
              </div>
              <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" />
            </div>
            <div
              :class="`achievements-contariner ${
                user.truly == undefined || user.truly == 0 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.truly > 0" class="count-icon">
                {{ user.truly }}
              </div>
              <img
                :src="$utils('icons', 'Outstanding_32')"
                alt="icons_Outstanding_32"
              />
            </div>
            <div
              :class="`achievements-contariner ${
                user.star < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.star > 0" class="count-icon">
                {{ user.star }}
              </div>
              <img
                :src="$utils('icons', 'Super_Star_32')"
                alt="icons_Super_Star_32"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mt-32 flex-mid"
      v-if="
        !showMoreDirectReport && user.boss && directReportsCardData.length > 3
      "
    >
      <span
        class="show-more-text"
        @click="showMoreDirectReport = !showMoreDirectReport"
      >
        {{ $t("weMonthlyInsights.growing.showMore") }} ({{
          directReportsCardData.length - 3
        }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      id: String,
      name: String,
      firstname: String,
      lastname: String,
      month: String,
      year: String,
      image: String,
    },
  },
  data() {
    return {
      activeGrowingTab: "directReports",
      showMoreDirectReport: false,
    };
  },
  computed: {
    growingData() {
      return this.$store.getters["monthlyEngaged/growingData"];
    },
    directReportsCardData() {
      return this.$store.getters["monthlyEngaged/directReportsCardData"];
    },
    userCardData() {
      return this.$store.getters["monthlyEngaged/userCardData"];
    },
    loadingStatus() {
      return this.$store.getters["monthlyEngaged/loadingStatus"];
    },
  },
  created() {
    //this.$store.dispatch("monthlyInsignhts/getUserTeam", this.user);
  },
  mounted() {},
  methods: {
    renameTalent(text) {
      console.log(text)
      if (text === "Latent Potential") {
        return "Starter";
      } else if (text == "Hidden Talent") {
        return "Hidden Gem";
      }
      return text;
    },
    showVideo() {
      this.$emit("dialogValue", { value: true, text: "section-5" });
    },
    growingCardStyle(value) {
      let style = "growing-card flex-center ";
      if (value.highlight) {
        style += "highlight ";
      } else if (value.grayBlock) {
        style += "gray-block ";
      }
      style += value.name;
      return style;
    },
    talentAndNetworkTagsStyle(value) {
      if (value == "Low Network" || value == "Latent Potential") {
        return "tag-red";
      } else if (
        value == "Medium Inner" ||
        value == "Medium Outer" ||
        value == "Medium Network" ||
        value == "Up-and-coming" ||
        value == "Contributor" ||
        value == "Community Pillar" ||
        value == "Rising Star" ||
        value == "Crowd Favorite"
      ) {
        return "tag-half-red";
      } else if (
        value == "High Outer" ||
        value == "High Inner" ||
        value == "High Potential" ||
        value == "Valued Contributor" ||
        value == "Untapped Potential" ||
        value == "Engaged Contributor" ||
        value == "Emerging Talent" ||
        value == "Unsung Talent" ||
        value == "Hidden Gem"
      ) {
        return "tag-orange";
      } else if (
        value == "Super Outer" ||
        value == "High Network" ||
        value == "Super Inner" ||
        value == "Activated" ||
        value == "Key Player" ||
        value == "Core Player" ||
        value == "Solid Performer" ||
        value == "High Performer"
      ) {
        return "tag-half-green";
      } else if (
        value == "Super Outer" ||
        value == "Superstar" ||
        value == "High Performer" ||
        value == "Respected Expert"||
        value == "Distinguished Talent"
      ) {
        return "tag-green";
      }
      return "tag-green";
    },
    toolTipStatus(value) {
      switch (value) {
        case "a":
          return this.$t("weMonthlyInsights.growing.LOW");
        case "b":
          return this.$t("weMonthlyInsights.growing.OKAY");
        case "c":
          return this.$t("weMonthlyInsights.growing.GREAT");
        case "d":
          return this.$t("weMonthlyInsights.growing.EXCELLENT");
      }
    },
    toolTipClass(value) {
      switch (value) {
        case "a":
          return "color: #F22F3C;";
        case "b":
          return "color: #C69312;";
        case "c":
          return "color: #27BC6C;";
        case "d":
          return "color: #27BC6C;";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.growing-container {
  .tab-header {
    transition: 0.3s;
    cursor: pointer;
    font-weight: 700;
    margin: auto;
    color: rgba($color: #15253c, $alpha: 0.5);
    position: relative;
    &:before {
      content: "";
      position: absolute;
      height: 2px;
      bottom: -1px;
      transition: 0.3s;
      background-color: #6d27bf;
      width: 0%;
    }
  }
  .tab-header.left {
    &:before {
      left: 100%;
    }
  }
  .tab-header.right {
    &:before {
      right: 100%;
    }
  }
  .tab-header.active-tab {
    color: #6d27bf;
    &:before {
      width: 100%;
    }
  }
  .tab-header.left.active-tab {
    &:before {
      left: 0;
    }
  }
  .tab-header.right.active-tab {
    &:before {
      right: 0;
    }
  }
  .growing-card {
    border-radius: 4px;
    width: 165px;
    height: 80px;
    margin: 4px;
    background-color: rgba($color: #000000, $alpha: 0.03);
    .title {
      font-size: 14px;
      font-weight: 700;
    }
    .value {
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
      background-color: #adabb0;
      color: #fff;
      margin-top: 5px;
      padding: 4px 9px 2px;
    }
  }
  .growing-card.Untapped.Potential.highlight,
  .growing-card.Untapped.Potential .value,
  .growing-card.Unsung.Talent.highlight,
  .growing-card.Unsung.Talent .value,
  .growing-card.Engaged.Contributor.highlight,
  .growing-card.Engaged.Contributor .value,
  .growing-card.Emerging.Talent.highlight,
  .growing-card.Emerging.Talent .value,
  .growing-card.Unsung.Talent.highlight,
  .growing-card.Unsung.Talent.value {
    background-color: #fbc02d;
    .value {
      color: #fbc02d;
    }
  }
  .growing-card.Activated.highlight,
  .growing-card.Activated .value,
  .growing-card.Key.Player.highlight,
  .growing-card.Key.Player .value,
  .growing-card.Core.Player.highlight,
  .growing-card.Core.Player .value,
  .growing-card.High.Potential.highlight,
  .growing-card.High.Potential .value {
    background-color: #c2e337;
    .value {
      color: #c2e337;
    }
  }
  .growing-card.High.Performer.highlight,
  .growing-card.High.Performer .value,
  .growing-card.Respected.Expert.highlight,
  .growing-card.Respected.Expert .value,
  .growing-card.Distinguished.Talent.highlight,
  .growing-card.Distinguished.Talent .value,
  .growing-card.Superstar.highlight,
  .growing-card.Superstar .value,
  .growing-card.Solid.Performer.highlight,
  .growing-card.Solid.Performer .value {
    background-color: #66bb6a;
    .value {
      color: #66bb6a;
    }
  }
  .growing-card.Community.Pillar.highlight,
  .growing-card.Community.Pillar .value,
  .growing-card.Up-and-Coming.highlight,
  .growing-card.Up-and-Coming .value,
  .growing-card.Rising.Star.highlight,
  .growing-card.Rising.Star .value,
  .growing-card.Contributor.highlight,
  .growing-card.Contributor .value,
  .growing-card.Crowd.Favorite.highlight,
  .growing-card.Crowd.Favorite .value {
    background-color: #ef8d3a;
    .value {
      color: #ef8d3a;
    }
  }
  .growing-card.Starter.highlight,
  .growing-card.Starter.value,
  .growing-card.Latent.Potential.highlight,
  .growing-card.Latent.Potential .value {
    background-color: #f44336;
    .value {
      color: #f44336;
    }
  }
  .growing-card.highlight {
    color: #fff;
    .value {
      background-color: #fff !important;
    }
  }
  .growing-card.gray-block {
    background-color: #adabb0;
    .title {
      color: #fff;
    }
    .value {
      color: #adabb0;
      background-color: #fff !important;
    }
  }
  .left-text {
    position: absolute;
    top: 200px;
    left: -110px;
    transform: rotate(-90deg);
    font-weight: 700;
    font-size: 16px;
    .left,
    .right {
      position: absolute;
      top: 46%;
      content: "";
      height: 2px;
      background-color: rgba($color: #000000, $alpha: 0.2);
    }
    .left {
      left: -105px;
      width: 90px;
    }
    .right {
      right: -80px;
      content: "";
      width: 65px;
      &:after {
        position: absolute;
        content: "";
        top: -4px;
        right: -24px;
        border: 12px solid rgba($color: #000000, $alpha: 0.2);
        border-width: 5px 12px;
        border-color: transparent transparent transparent
          rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
  .line-label {
    width: 100%;
    margin-left: auto;
    text-align: center;
    border-bottom: 2px solid rgba($color: #000000, $alpha: 0.2);
    line-height: 0.1em;
    margin: 10px 0 10px;
  }

  .line-label span.label {
    background: #fff;
    padding: 0 16px;
  }
  .line-label span.arrow {
    position: absolute;
    content: "";
    height: 0;
    right: 18px;
    content: "";
    width: 0;
    &:after {
      position: absolute;
      content: "";
      top: -3px;
      right: -24px;
      border: 12px solid rgba($color: #000000, $alpha: 0.2);
      border-width: 5px 12px;
      border-color: transparent transparent transparent
        rgba($color: #000000, $alpha: 0.2);
    }
  }
  .profile-card {
    box-shadow: 0 3px 6px #00000029;
    border-radius: 6px;
    .profile {
      border: 1px solid #00000033;
      padding: 12px;
    }
    .profile.top {
      border-radius: 6px 6px 0 0;
      border-width: 1px 1px 0 1px;
      .talent {
        padding: 7px 16px 5px;
        border-radius: 16px;
        color: #ffffff;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: 700;
        font-family: "Lato", sans-serif;
        margin-left: 14px;
      }
      .talent.old {
        background-color: rgba($color: #000000, $alpha: 0.3);
      }
      .talent.now {
        background-color: #6d27bf;
      }
    }
    .profile.bottom {
      border-radius: 0 0 6px 6px;
      border-width: 0 1px 1px 1px;
      background-color: rgba($color: #000000, $alpha: 0.04);
      // .excels-at {
      //   color: #fff;
      //   background-color: #0caca5;
      //   font-weight: 700;
      //   height: 26px;
      //   border-radius: 4px;
      //   margin-top: 4px;
      //   margin-bottom: 4px;
      //   .text {
      //     padding: 6px 8px 5px;
      //     font-size: 13px;
      //   }
      //   .value {
      //     font-size: 11px;
      //     border-radius: 0 4px 4px 0;
      //     padding: 7px 10px 5px;
      //     background-color: rgba($color: #000000, $alpha: 0.3);
      //   }
      // }
      // .star-truly {
      //   position: relative;
      //   font-family: "Lato", sans-serif;
      //   .star {
      //     width: 32px;
      //     height: 32px;
      //     border-radius: 32px;
      //     background-color: grey;
      //   }
      //   .value {
      //     position: absolute;
      //     bottom: 0;
      //     left: 18px;
      //     background-color: #f22f3c;
      //     width: 18px;
      //     height: 16px;
      //     border-radius: 18px;
      //     color: #fff;
      //     font-weight: 700;
      //     font-size: 12px;
      //     padding-top: 2px;
      //   }
      // }
      .achievements-contariner {
        width: 32px;
        margin-right: 6px;
        position: relative;
        .count-icon {
          position: absolute;
          top: -4px;
          right: -4px;
          height: 16px;
          min-width: 16px;
          padding: 0 1px;
          text-align: center;
          border-radius: 32px;
          background-color: #343434;
          color: #ffffff;
          font-size: 11px;
          font-weight: 700;
          line-height: 19px;
        }
      }
      .achievements-contariner.no-have {
        opacity: 0.2;
        > img {
          filter: grayscale(100%);
        }
      }
      .cell.c-FBC02D {
        background: #fbc02d;
      }
      .cell.c-C2E337 {
        background: #c2e337;
      }
      .cell.c-66BB6A {
        background: #66bb6a;
      }
      .cell.c-EF8D3A {
        background: #ef8d3a;
      }
      .cell.c-F44336 {
        background: #f44336;
      }
    }
  }
  .show-more-text {
    padding: 8px 24px;
    cursor: pointer;
    border-radius: 16px;
    background-color: rgba($color: #b2b2b2, $alpha: 0.3);
    color: rgba($color: #000000, $alpha: 0.7);
  }
}
.talent-tag {
  width: 96px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 700;
  border-radius: 4px;
}
.tag-red {
  background-color: rgba(#f44336, 0.3);
  color: #6e1d17;
}
.tag-half-red {
  background-color: rgba(#ef8d3a, 0.3);
  color: #6f3f16;
}
.tag-orange {
  background-color: rgba(#fbc02d, 0.3);
  color: #745301;
}
.tag-half-green {
  background-color: rgba(#c2e337, 0.3);
  color: #43500d;
}
.tag-green {
  background-color: rgba(#66bb6a, 0.3);
  color: #124314;
}
.impact-tag {
  padding: 1px 0px 0px;
  text-align: center;
  width: 52px;
  height: 32px;
  border-radius: 4px;
  font-size: 15px;
}
.impact-tag-red {
  background-color: rgba(#f44336, 0.3);
  color: #6e1d17;
}
.impact-tag-yellow {
  background-color: rgba(#fbc02d, 0.3);
  color: #745301;
}
.impact-tag-green {
  background-color: rgba(#66bb6a, 0.3);
  color: #28642a;
}
.tooltop {
  padding: 6px;
  width: 350px;
}
</style>
